import { fromJS } from 'immutable';

export const VOLCANO_LOCATION_SEARCH_TOGGLE_PARAMETERS = 'VOLCANO_LOCATION_SEARCH_TOGGLE_PARAMETERS';

const initialState = fromJS({
  expanded: true,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const volcanoLocationSearchPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case VOLCANO_LOCATION_SEARCH_TOGGLE_PARAMETERS:
      return state.set('expanded', !state.get('expanded'));

    default:
      return state;
  }
};
